export default __webpack_public_path__ + "static/media/anniversary_ring.15426216.webp";